import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

let IconSignOut = (props) => {
  props = Object.assign({viewBox: '0 0 42 32'}, props);
  return (
    <SvgIcon {...props}>
      <path d="M33.328 7.094l-1.509 1.509 6.309 6.309h-26.023v2.174h26.023l-6.672 6.672 1.509 1.54 9.298-9.298-8.936-8.906z"/>
      <path d="M22.309 29.857h-20.136v-27.683h20.136v4.226h2.174v-6.4h-24.483v32h24.483v-6.491h-2.174v4.347z"/>
    </SvgIcon>
  );
};
// IconEdit = pure(IconEdit);
IconSignOut.displayName = 'IconEdit';
IconSignOut.muiName = 'SvgIcon';

export default IconSignOut;



// WEBPACK FOOTER //
// ./src/components/Icons/IconSignOut.js